export const lightBg = 'gpgp_bg_light.png';
export const darkBg = 'gpgp_bg_dark.png';
